module.exports = __webpack_public_path__ + "files/aphp.5b36ad43218bfbb439c0e60cdbc18255.pdf";